const options = [
  { speed: "24-Hour Rush", time: "1 Business Day", price: "From $599", badge: "Fastest", badgeColor: "bg-[#F6C344] text-[#1A365D]", highlight: true },
  { speed: "2-Day Expedited", time: "2 Business Days", price: "From $399", badge: "Popular", badgeColor: "bg-[#1A365D] text-white", highlight: false },
  { speed: "5-Day Expedited", time: "5 Business Days", price: "From $299", badge: "Standard", badgeColor: "bg-gray-200 text-gray-700", highlight: false },
  { speed: "9-Day Expedited", time: "7–9 Business Days", price: "From $249", badge: "Economy", badgeColor: "bg-gray-100 text-gray-600", highlight: false },
];

export default function HammondProcessingTimeSection() {
  return (
    <section id="processing" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Processing Options</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Processing Times for Hammond
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are a SLU student heading to study abroad, a Tangipahoa Parish family planning a Caribbean cruise, or a Northshore professional with upcoming international travel, we have a processing speed to fit your timeline and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
          {options.map((opt, i) => (
            <div
              key={i}
              className={`relative rounded-lg p-6 flex flex-col border transition-all ${
                opt.highlight
                  ? "bg-[#1A365D] border-[#1A365D] text-white"
                  : "bg-[#F7F8FA] border-gray-200 hover:border-[#1A365D]"
              }`}
            >
              <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full mb-4 self-start ${opt.badgeColor}`}>
                {opt.badge}
              </span>
              <h3 className={`font-bold text-lg mb-1 ${opt.highlight ? "text-[#F6C344]" : "text-[#1A365D]"}`}>{opt.speed}</h3>
              <p className={`text-sm mb-4 ${opt.highlight ? "text-white/70" : "text-gray-500"}`}>{opt.time}</p>
              <p className={`font-bold text-2xl mt-auto ${opt.highlight ? "text-white" : "text-[#1A365D]"}`}>{opt.price}</p>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className={`mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-bold px-4 py-2.5 rounded-md transition-all whitespace-nowrap ${
                  opt.highlight
                    ? "bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D]"
                    : "bg-[#1A365D] hover:bg-[#0F2240] text-white"
                }`}
              >
                Select <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg border border-gray-200 p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
            <i className="ri-information-line text-white text-xl"></i>
          </div>
          <div>
            <p className="font-bold text-[#1A365D] text-sm mb-1">Government Processing vs. Our Expedited Service</p>
            <p className="text-gray-500 text-sm leading-relaxed">
              The U.S. government currently takes <strong className="text-[#1A365D]">10–13 weeks</strong> for routine processing and <strong className="text-[#1A365D]">6–9 weeks</strong> for expedited government service. Our service bypasses these timelines. As a registered U.S. Department of State courier, we are not a reseller — which means our best price guarantee is real.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}